// extracted by mini-css-extract-plugin
export var wrapper = "Hero-module--wrapper--0FaKp";
export var content = "Hero-module--content--zNDDW";
export var textBlok = "Hero-module--textBlok--1sqTf";
export var headline = "Hero-module--headline--T80jH";
export var text = "Hero-module--text--xBO16";
export var illustration = "Hero-module--illustration--sTqHy";